import React from 'react';
import { useAutomaticFontSizing } from '../lib/useAutomaticFontSizing';

interface IProps {
  width: number;
  height: number;
  value: string;
  fontFamily: string;
  fontSize: number;
  updateBlock: Function;
  parentRef: React.RefObject<any>;
  pageScale: number;
  blockType: string;
  dataSpec: string;
}

const AutosizingBlock = (props: IProps) => {
  const textRef = React.useRef<HTMLDivElement>(null);

  const { fontSize } = useAutomaticFontSizing({
    height: props.height!,
    width: props.width!,
    initialFontSize: props.fontSize,
    initialValue: props.value,
    fontFamily: props.fontFamily,
    blockType: props.blockType,
  });

  React.useEffect(() => {
    props.updateBlock({ fontSize });
  }, [fontSize]);

  return (
    <div data-spec={props.dataSpec} ref={textRef} style={{ 
      fontSize: fontSize * props.pageScale,
      fontWeight: props.fontFamily === 'courier' ? 'bold' : 'normal'
    }}>
      {props.value}
    </div>
  );
};

export default AutosizingBlock;
